<template>
  <section class="relative overflow-hidden bg-gray-100 pt-[114px] pb-[114px] mb-12 md:mb-14">
    <SectionWaves />
    <div class="relative z-10 container mx-auto max-w-[1200px] px-4 py-12 md:py-16">
      <h2 class="landing_h2 mb-6 text-center">
        <Translate translate-key="earnings_potential.title" />
      </h2>
      <div
        class="grid w-full gap-6 leading-relaxed md:grid-cols-2 prose prose-gray max-w-none prose-p:mb-3 prose-ul:my-3 prose-li:my-0.5 prose-a:text-success"
      >
        <div>
          <Translate
            class="flex pb-2"
            translate-key="earnings_potential.text_1"
          />
          <ul class="list-disc pl-5">
            <Translate translate-key="earnings_potential.list_1" />
          </ul>
        </div>
        <div
          class="overflow-x-auto [&_table]:border-2 [&_table]:border-gray-500 [&_table]:border-collapse [&_table]:m-auto [&_th]:border-2 [&_th]:border-gray-500 [&_th]:p-3 [&_th]:text-center [&_th]:relative [&_td]:border-2 [&_td]:border-gray-500 [&_td]:p-3 [&_td]:text-center [&_td]:relative [&_.correct]:after:content-['✓'] [&_.correct]:after:text-xl [&_.correct]:after:text-success [&_.question-block_.question]:after:content-['?'] [&_.question-block_.question]:after:text-2xl [&_.question-block_.question]:after:text-gray-400"
          v-html="t('earnings_potential.table')"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import SectionWaves from "~/features/landing-page/components/sections/SectionWaves.vue";
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
